/**
 * @generated SignedSource<<864e45ca76bab80383118af85f7ca992>>
 * @relayHash 800e55713d6ff0b2d67a022038d6f49f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba69b53647ebeade5442124d748de18662d6c015e17aa4c395d8ff5ec61dfbc1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { issueNotificationsQuery } from './issueNotificationsQuery.graphql';

const node: PreloadableConcreteRequest<issueNotificationsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ba69b53647ebeade5442124d748de18662d6c015e17aa4c395d8ff5ec61dfbc1",
    "metadata": {},
    "name": "issueNotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
